/** Count numeric digits (0–9) in a phone string; ignores spaces, +, dashes, etc. */
export function countPhoneDigits(phone: string): number {
  return (phone.match(/\d/g) || []).length;
}

export const MIN_FUND_DECK_PHONE_DIGITS = 10;

export function isValidFundDeckPhone(phone: string): boolean {
  return countPhoneDigits(phone) >= MIN_FUND_DECK_PHONE_DIGITS;
}

export const FUND_DECK_PHONE_ERROR = 'Please enter a phone number with at least 10 digits.';
